/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Mfa_Challenge_InvalidInputs */

const en_error_mfa_challenge_invalid = /** @type {(inputs: Error_Mfa_Challenge_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This sign-in has expired or had too many wrong codes. Sign in again.`)
};

/**
* | output |
* | --- |
* | "This sign-in has expired or had too many wrong codes. Sign in again." |
*
* @param {Error_Mfa_Challenge_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_mfa_challenge_invalid = /** @type {((inputs?: Error_Mfa_Challenge_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Mfa_Challenge_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_mfa_challenge_invalid(inputs)
});